<script setup>
  import { computed } from 'vue'
  import UpgradeButton from '@/components/UpgradeButton.vue';
  import Icon from '@/components/icons/Icon.vue';
  
  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    },
    productText: {
      type: String,
      required: true
    }
  })

  const messageText = computed(() => {
    if (!props.upgrade || !props.upgrade[1] || props.upgrade[1].length === 0) return `Upgrade to unlock ${props.productText}`;
    
    return `Upgrade to <strong>${formatMembershipLevels(props.upgrade[1])}</strong> to unlock ${props.productText}`
  });

  const buttonText = computed(() => {
    if (props.upgrade[2] === null) return 'Upgrade Now';

    return props.upgrade[2] ? 'Start Free Trial' : 'Upgrade Now';
  });

  // TODO: move to composable?
  function formatMembershipLevels(levels) {
    return levels.map((level, i) => {
      const capitalizedLevel = `${level[0].toUpperCase()}${level.slice(1)}`;

      if (i === 0) return capitalizedLevel;

      if (levels.length > 2) {
        return i < levels.length - 1 
          ? `, ${capitalizedLevel}` 
          : `, or ${capitalizedLevel}`
      };

      return ` or ${capitalizedLevel}`
    }).join('');
  }
</script>

<template>
  <div class="jwx-upgrade-block-container">
    <div class="jwx-upgrade-block jwx-button-shadow">
      <p class="jwx-upgrade-block__text">
        <slot></slot>
      </p>
      <Icon name="lock-unlocked" class="jwx-upgrade-block__icon" />
      <p v-html="messageText" class="jwx-upgrade-block__text"></p>
      <UpgradeButton :buttonText="buttonText" />
    </div>   
  </div>
</template>